/* tslint:disable:max-line-length */
import { DefaultMessages, RequestOrganizationMessages } from '@sheerid/jslib';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

type ThisProjectMessages = {
    locales: {
        en: string, // need to support `en` in additon to `en-US` for ADSK's requirements
        is: string, // need to support `is` for ADSK's requirements
        ro: string, // need to support `ro` for ADSK's requirements
    },
    countries: {
        CD: string, // the jslib doesn't include a country code for Democratic Republic of Congo
        CZ: string, // the jslib uses the incorrect country code for Czech Republic
        PS: string, // the jslib doesn't include a country code for Palestine
        SS: string, // the jslib doesn't include a country code for South Sudan
        TL: string, // the jslib doesn't include a country code for Timor-Leste
    },
};


type LibraryMessages = DefaultMessages & RequestOrganizationMessages;

export const huRequestOrgMessages: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    title: 'Iskola felvételének kérése',
    description: 'Kérjük, töltse ki az alábbi űrlapot. A benyújtott iskolák hozzáadása nem garantált, de a SheerID minden igényt megvizsgál és figyelembe vesz. ',
    noCountry: 'Nem látja az iskolájának országát? Nem jogosult ehhez az ajánlathoz',
    searchByOrgName: 'Nem látja az iskoláját? Keresse név szerint',
    completeRequest: 'Nem látja iskoláját a támogatható vagy nem támogatható iskolák listáján? Töltse ki kérését',
    submit: 'Beküldés',
    eligibleOrgs: 'Támogatható iskolák. Kattintson az ikonra a név másolásához, majd térjen vissza az ellenőrző űrlaphoz',
    ineligibleOrgs: 'Nem támogatható iskolák. Sajnáljuk, ezen iskolák diákjai nem jogosultak erre az ajánlatra',
    none: 'Egyik sem',
    country: 'Hova jár iskolába?',
    changeLanguage: 'Válts nyelvet',
    copied: 'másolt',
    firstName: 'Keresztnév',
    lastName: 'Vezetéknév',
    emailAddress: 'E-mail',
    poweredBy: 'A SheerID által biztosított hitelesítési szolgáltatások',
    fields: {
        countryPlaceholder: 'Válasszon országot',
        domainLabel: 'Az iskola weboldala',
        domainPlaceholder: 'www.egyetemem.hu',
        orgNameLabel: 'Iskola neve',
        orgNamePlaceholder: 'Az iskolám',
    },
    step: {
        success: {
            title: 'Köszönjük, hogy elküldte iskolája igényét',
            description: 'Emlékeztetjük, hogy a kéréseket a SheerID bírálja el a jelen ajánlat követelményeinek megfelelően. Az iskola hozzáadása nem garantált. A kiértékelés akár 7 napig is tarthat.',
        },
        error: {
            title: 'Egy váratlan hiba történt',
            description: 'Sajnos nem tudjuk feldolgozni a kérését. Kérjük, próbálja újra később.',
            seeingProblem: 'Ha továbbra is ezt a problémát látja,',
            contactUs: 'vegye fel velünk a kapcsolatot',
        },
    },
    errorId: {
        invalidCountry: 'Kötelező mező',
        invalidEmail: 'Érvénytelen e-mail',
        invalidFirstName: 'Érvénytelen keresztnév',
        invalidLastName: 'Érvénytelen vezetéknév',
        requiredField: 'Kötelező mező',
        invalidField: 'A mező érvénytelen',
        invalidUrl: 'Érvénytelen URL',
        tooManyResults: 'A keresés túl sok találatot adott, kérjük, finomítsa a keresést, és próbálja újra',
    },
    faq: 'SheerID oktatási igénylés hozzáadása - GYIK',
    countries: {
        AD: 'Andorra',
        AE: 'Egyesült Arab Emírségek',
        AF: 'Afganisztán',
        AG: 'Antigua és Barbuda',
        AI: 'Anguilla',
        AL: 'Albánia',
        AM: 'Örményország',
        AN: 'Holland Antillák',
        AO: 'Angola',
        AR: 'Argentína',
        AS: 'Amerikai Szamoa',
        AT: 'Ausztria',
        AU: 'Ausztrália',
        AW: 'Aruba',
        AZ: 'Azerbajdzsán',
        BA: 'Bosznia-Hercegovina',
        BB: 'Barbados',
        BD: 'Banglades',
        BE: 'Belgium',
        BF: 'Burkina Faso',
        BG: 'Bulgária',
        BH: 'Bahrein',
        BI: 'Burundi',
        BJ: 'Benin',
        BM: 'Bermuda',
        BN: 'Brunei Darussalam',
        BO: 'Bolívia',
        BR: 'Brazília',
        BS: 'Bahamák',
        BT: 'Bhután',
        BV: 'Bouvet-sziget',
        BW: 'Botswana',
        BY: 'Fehéroroszország',
        BZ: 'Belize',
        CA: 'Kanada',
        CD: 'Kongói Demokratikus Köztársaság',
        CF: 'Közép-afrikai Köztársaság',
        CG: 'Kongó',
        CH: 'Svájc',
        CI: 'Elefántcsontpart (Cote D\'Ivoire)',
        CK: 'Cook-szigetek',
        CL: 'Chile',
        CM: 'Kamerun',
        CN: 'Kína',
        CO: 'Kolumbia ',
        CR: 'Costa Rica',
        CU: 'Kuba',
        CV: 'Zöld-foki Köztársaság',
        CY: 'Ciprus',
        CZ: 'Cseh Köztársaság',
        DE: 'Németország',
        DJ: 'Dzsibuti',
        DK: 'Dánia',
        DM: 'Dominika',
        DO: 'Dominikai Köztársaság',
        DZ: 'Algéria',
        EC: 'Ecuador',
        EE: 'Észtország',
        EG: 'Egyiptom',
        EH: 'Nyugat-Szahara',
        ER: 'Eritrea',
        ES: 'Spanyolország',
        ET: 'Etiópia',
        FI: 'Finnország',
        FJ: 'Fidzsi-szigetek',
        FK: 'Falkland-szigetek',
        FM: 'Mikronézia',
        FO: 'Feröer-szigetek',
        FR: 'Franciaország',
        GA: 'Gabon',
        GB: 'Egyesült Királyság',
        GD: 'Grenada',
        GE: 'Grúzia',
        GF: 'Francia Guyana',
        GH: 'Ghána',
        GI: 'Gibraltár',
        GL: 'Grönland',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadeloupe (FR)',
        GQ: 'Egyenlítői-Guinea',
        GR: 'Görögország',
        GS: 'Dél-Georgia és Dél-Sandwich-szigetek',
        GT: 'Guatemala',
        GU: 'Guam (USA)',
        GW: 'Bissau-Guinea',
        GY: 'Guyana',
        HK: 'Hongkong',
        HM: 'Heard-sziget és McDonald-szigetek',
        HN: 'Honduras',
        HR: 'Horvátország',
        HT: 'Haiti',
        HU: 'Magyarország',
        ID: 'Indonézia',
        IE: 'Írország',
        IL: 'Izrael',
        IN: 'India',
        IO: 'Brit Indiai-óceáni Terület',
        IQ: 'Irak',
        IR: 'Irán',
        IS: 'Izland',
        IT: 'Olaszország',
        JM: 'Jamaica',
        JO: 'Jordánia',
        JP: 'Japán',
        KE: 'Kenya',
        KG: 'Kirgizisztán',
        KH: 'Kambodzsa',
        KI: 'Kiribati',
        KM: 'Comore-szigetek',
        KN: 'Saint Kitts és Nevis Anguilla',
        KP: 'Észak-Korea',
        KR: 'Dél-Korea',
        KW: 'Kuvait',
        KY: 'Kajmán-szigetek',
        KZ: 'Kazahsztán',
        LA: 'Laosz',
        LB: 'Libanon',
        LC: 'Saint Lucia',
        LI: 'Liechtenstein',
        LK: 'Srí Lanka',
        LR: 'Libéria',
        LS: 'Lesotho',
        LT: 'Litvánia',
        LU: 'Luxemburg',
        LV: 'Lettország',
        LY: 'Líbia',
        MA: 'Marokkó',
        MC: 'Monaco',
        MD: 'Moldva',
        ME: 'Montenegró',
        MG: 'Madagaszkár',
        MH: 'Marshall-szigetek',
        MK: 'Macedónia',
        ML: 'Mali',
        MM: 'Mianmar',
        MN: 'Mongólia',
        MO: 'Macau',
        MP: 'Észak-Mariana-szigetek',
        MQ: 'Martinique (FR)',
        MR: 'Mauritánia',
        MS: 'Montserrat',
        MT: 'Málta',
        MU: 'Mauritius',
        MV: 'Maldív-szigetek',
        MW: 'Malawi',
        MX: 'Mexikó',
        MY: 'Malajsia',
        MZ: 'Mozambik',
        NA: 'Namíbia',
        NC: 'Új-Kaledónia (FR)',
        NE: 'Niger',
        NF: 'Norfolk-sziget',
        NG: 'Nigéria',
        NI: 'Nicaragua',
        NL: 'Hollandia',
        NO: 'Norvégia',
        NP: 'Nepál',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'Új-Zéland',
        OM: 'Omán',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'Polinézia (FR)',
        PG: 'Pápua Új-Guinea',
        PH: 'Fülöp-szigetek',
        PK: 'Pakisztán',
        PL: 'Lengyelország',
        PM: 'Saint Pierre és Miquelon',
        PN: 'Pitcairn-sziget',
        PR: 'Puerto Rico',
        PS: 'Palesztina',
        PT: 'Portugália',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Katar',
        RE: 'Reunion (FR)',
        RO: 'Románia',
        RS: 'Szerbia',
        RU: 'Orosz Föderáció',
        RW: 'Ruanda',
        SA: 'Szaud-Arábia',
        SB: 'Salamon-szigetek',
        SC: 'Seychelles',
        SD: 'Szudán',
        SE: 'Svédország',
        SG: 'Szingapúr',
        SH: 'Saint Helena',
        SI: 'Szlovénia',
        SK: 'Szlovák Köztársaság',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Szenegál',
        SO: 'Szomália',
        SR: 'Suriname',
        SS: 'Dél Szudán',
        ST: 'São Tomé és Príncipe',
        SV: 'El Salvador',
        SY: 'Szíria',
        SZ: 'Szváziföld',
        TC: 'Turks-és Caicos-szigetek',
        TD: 'Csád',
        TF: 'Francia Déli- és Antarktiszi-területek',
        TG: 'Togo',
        TH: 'Thaiföld',
        TJ: 'Tádzsikisztán',
        TK: 'Tokelau',
        TL: 'Kelet-Timor',
        TM: 'Türkmenisztán',
        TN: 'Tunézia',
        TO: 'Tonga',
        TR: 'Törökország',
        TT: 'Trinidad és Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tanzánia',
        UA: 'Ukrajna',
        UG: 'Uganda',
        UM: 'Az Amerikai Egyesült Államok lakatlan külbirtokai',
        US: 'Amerikai Egyesült Államok',
        UY: 'Uruguay',
        UZ: 'Üzbegisztán',
        VA: 'Vatikánvárosi állam',
        VC: 'Saint Vincent és a Grenadine-szigetek',
        VE: 'Venezuela',
        VG: 'Brit Virgin-szigetek',
        VI: 'Virgin-szigetek (USA)',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis- és Futuna-szigetek ',
        WS: 'Szamoa',
        XK: 'Koszovó',
        YE: 'Jemen',
        YT: 'Mayotte',
        ZA: 'Dél-afrikai Köztársaság',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
    },
    locales: {
        ar: 'arab',
        bg: 'bolgár',
        cs: 'cseh',
        da: 'dán',
        de: 'német',
        el: 'görög',
        'en-GB': 'angol (GB)',
        'en-US': 'angol',
        'es-ES': 'spanyol (ES)',
        es: 'spanyol',
        fi: 'finn',
        'fr-CA': 'francia (CA)',
        fr: 'francia',
        hr: 'horvát',
        hu: 'magyar',
        id: 'indonéz',
        is: 'izlandi',
        it: 'olasz',
        iw: 'héber',
        ja: 'japán',
        ko: 'koreai',
        lt: 'litván',
        ms: 'maláj',
        nl: 'holland',
        no: 'norvég',
        pl: 'lengyel',
        'pt-BR': 'portugál (BR)',
        pt: 'portugál',
        ro: 'román',
        ru: 'Oroszország',
        sk: 'szlovák',
        sl: 'szlovén',
        sr: 'szerb',
        sv: 'svéd',
        tr: 'török',
        'zh-HK': 'kínai (Hongkong)',
        zh: 'kínai (hagyományos)',
    },
};
